import { render, staticRenderFns } from "./FixtureRedeemAssets.vue?vue&type=template&id=050f5c0c&"
import script from "./FixtureRedeemAssets.vue?vue&type=script&lang=js&"
export * from "./FixtureRedeemAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports